export const prerequisitesConfig = [
  {
    id: 'hasAccessedMpc',
    text: "I've accessed and used my Microsoft Partner Center Account.",
  },
  {
    id: 'hasEnrolledInCommercialMarketplace',
    text: "I've enrolled in commercial marketplace and registered in Microsoft Cloud Partner Program.",
  },
  {
    id: 'hasCompletedOrganizationProfile',
    text: "I've completed my organization profile, payout and tax profile.",
  },
]
